import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const GET_ORG = 'sherrinford/organisation/GET_ORG'

export const CURRENT_ORG_ID = 'sherrinford/organisation/CURRENT_ORG_ID'

export const ORG_GROUP_REQUEST = 'sherrinford/organisation/ORG_GROUP_REQUEST'
export const ORG_GROUP_SUCCESS = 'sherrinford/organisation/ORG_GROUP_SUCCESS'
export const ORG_GROUP_ERROR = 'sherrinford/organisation/ORG_GROUP_ERROR'

export const ORG_PRODUCTS_REQUEST = 'sherrinford/organisation/ORG_PRODUCTS_REQUEST'
export const ORG_PRODUCTS_SUCCESS = 'sherrinford/organisation/ORG_PRODUCTS_SUCCESS'
export const ORG_PRODUCTS_ERROR = 'sherrinford/organisation/ORG_PRODUCTS_ERROR'

export const ORG_PROJECTS_REQUEST = 'sherrinford/organisation/ORG_PROJECTS_REQUEST'
export const ORG_PROJECTS_SUCCESS = 'sherrinford/organisation/ORG_PROJECTS_SUCCESS'
export const ORG_PROJECTS_ERROR = 'sherrinford/organisation/ORG_PROJECTS_ERROR'

export const ORG_BY_ID_REQUEST = 'sherrinford/organisation/ORG_BY_ID_REQUEST'
export const ORG_BY_ID_SUCCESS = 'sherrinford/organisation/ORG_BY_ID_SUCCESS'
export const ORG_BY_ID_ERROR = 'sherrinford/organisation/ORG_BY_ID_ERROR'

export const ORG_BY_TEAM_REQUEST = 'sherrinford/organisation/ORG_BY_TEAM_REQUEST'
export const ORG_BY_TEAM_SUCCESS = 'sherrinford/organisation/ORG_BY_TEAM_SUCCESS'
export const ORG_BY_TEAM_ERROR = 'sherrinford/organisation/ORG_BY_TEAM_ERROR'

export const ORG_BY_GROUP_REQUEST = 'sherrinford/organisation/ORG_BY_GROUP_REQUEST'
export const ORG_BY_GROUP_SUCCESS = 'sherrinford/organisation/ORG_BY_GROUP_SUCCESS'
export const ORG_BY_GROUP_ERROR = 'sherrinford/organisation/ORG_BY_GROUP_ERROR'

const initialState = {
  isLoading: false,
  groups: [],
  orgProducts: [],
  orgProjects: [],
  orgById: {},
  orgByTeam: {},
  orgByGroup: [],
}

export default createReducer(initialState, {
  [GET_ORG]: (state, { groups }) => ({
    ...state,
    groups,
  }),

  [ORG_GROUP_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_GROUP_SUCCESS]: (state, res) => {
    const groups = res

    return {
      ...state,
      isLoading: false,
      groups,
    }
  },

  [ORG_GROUP_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [ORG_PRODUCTS_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_PRODUCTS_SUCCESS]: (state, res) => {
    const orgProducts = res
    return {
      ...state,
      isLoading: false,
      orgProducts,
    }
  },

  [ORG_PRODUCTS_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [ORG_PROJECTS_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_PROJECTS_SUCCESS]: (state, res) => {
    const orgProjects = res[0]
    return {
      ...state,
      isLoading: false,
      orgProjects,
    }
  },

  [ORG_PROJECTS_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [ORG_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_BY_ID_SUCCESS]: (state, res) => {
    const orgById = res
    return {
      ...state,
      isLoading: false,
      orgById,
    }
  },

  [ORG_BY_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [ORG_BY_TEAM_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_BY_TEAM_SUCCESS]: (state, res) => {
    const orgByTeam = res
    return {
      ...state,
      isLoading: false,
      orgByTeam,
    }
  },

  [ORG_BY_TEAM_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [ORG_BY_GROUP_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [ORG_BY_GROUP_SUCCESS]: (state, res) => {
    const orgByGroup = res
    return {
      ...state,
      isLoading: false,
      orgByGroup,
    }
  },

  [ORG_BY_GROUP_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

})

export const getOrgGroup = () => ({
  type: [
    ORG_GROUP_REQUEST,
    ORG_GROUP_SUCCESS,
    ORG_GROUP_ERROR,
  ],
  shuttle: {
    method: 'GET',
    path: '/group',
  },
})

export const getOrgProducts = (id) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      ORG_PRODUCTS_REQUEST,
      ORG_PRODUCTS_SUCCESS,
      ORG_PRODUCTS_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/product/organisation/${id}`,
      authorization: `${token}`,
    },
  }
}

export const getOrgProjects = (id) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      ORG_PROJECTS_REQUEST,
      ORG_PROJECTS_SUCCESS,
      ORG_PROJECTS_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/organisation/${id}/project`,
      authorization: `${token}`,
    },
  }
}

export const getOrgById = (id) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      ORG_BY_ID_REQUEST,
      ORG_BY_ID_SUCCESS,
      ORG_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/organisation/${id}`,
      authorization: `${token}`,
    },
  }
}

export const getOrgByTeam = (team) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      ORG_BY_TEAM_REQUEST,
      ORG_BY_TEAM_SUCCESS,
      ORG_BY_TEAM_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/organisation/team/${team}`,
      authorization: `${token}`,
    },
  }
}

export const getOrgByGroupSlug = slug => ({
  type: [
    ORG_BY_GROUP_REQUEST,
    ORG_BY_GROUP_SUCCESS,
    ORG_BY_GROUP_ERROR,
  ],
  shuttle: {
    method: 'GET',
    path: `/organisation/group/${slug}`,
  },
})

export const setCurrentOrgId = orgId => ({ type: [CURRENT_ORG_ID], payload: orgId })
